import { render } from "./AbogModal.vue?vue&type=template&id=62f879e4"
import script from "./AbogModal.vue?vue&type=script&lang=js"
export * from "./AbogModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__